












































































//@ts-ignore
import NaijaStates from "naija-state-local-government";
import { db } from "@/firebase/firebase";
import { countries } from "@/store/hardData";
import { Client } from "@/interfaces/interfaces";
import { useMainStore } from "@/store/storage";
import {
  computed,
  defineComponent,
  reactive,
  toRefs
} from "@vue/composition-api";
import moment from "moment";
export default defineComponent({
  name: "ClientList",
  setup(props, { root }) {
    const main = useMainStore();
    const state = reactive({
      formStatus: false,
      clients: [] as Client[],
      headers: [
        {
          text: " Client Name",
          value: "companyName",
          align: "start",
          sortable: true
        },
        {
          text: " Mobile",
          value: "mobile",
          align: "start",
          sortable: true
        },
        {
          text: " Email",
          value: "email",
          align: "start",
          sortable: true
        }
      ],
      activeItem: 0,
      search: ""
    });

    const NigeriaInfo = reactive({
      NigeriaStates: NaijaStates.states(),
      NigeriaLGA: NaijaStates.lgas(main.state.clientData.state)
    });

    function clearStates() {
      main.state.clientData.state = "";
      NigeriaInfo.NigeriaLGA = NaijaStates.lgas(main.state.clientData.state);
    }
    function clearLGA() {
      NigeriaInfo.NigeriaLGA = NaijaStates.lgas(main.state.clientData.state);
      main.state.clientData.LGA = "";
    }
    function resetClientData() {
      main.state.clientData = {
        companyName: "",
        addressLine1: "",
        addressLine2: "",
        country: "Nigeria",
        state: "Rivers",
        LGA: "Port-Harcourt",
        mobile: "",
        email: "",
        registrationDate: moment().format("YYYY-MM-DD")
      };
    }

    function setItem(item: Client) {
      // main.resetEnrolee(item.id);
      main.state.clientData = item;
      main.state.clientId = item.id as string;
      main.resetProjectData();
      // main.state.enroleesDefault.companyId = item.id as string;

      // "setItem -> main.state.enroleesDefault.companyId",
      // main.state.enroleesDefault.companyId
      // );
    }

    function removeItem(item: Client) {
      if (confirm("Are you sure you want to permanently delete this record?")) {
        if (item.id) {
          db.collection("clients")
            .doc(item.id)
            .delete();
          main.resetClientData();
        }
      }
    }
    const clientsFiltered = computed(() => {
      return main.state.clients.filter((item) => {
        if (state.search !== "") {
          return item.companyName.toLowerCase().includes(state.search);
        } else {
          return true;
        }
      });
    });

    function addClient() {
      root.$emit("showclientform", true);
      main.resetClientData;
    }

    return {
      mainStore: main,
      mainState: main.state,
      resetform: main.resetClientData,
      clientsFiltered,
      ...toRefs(state),
      ...toRefs(NigeriaInfo),
      countries,
      clearStates,
      clearLGA,
      resetClientData,
      setItem,
      removeItem,
      addClient
    };
  }
});
